import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAnnotationNumbers24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconAnnotationNumbers24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.996 8.155v7.272h1.536v-8.4H4.76L3.044 10.82h1.608L5.78 8.155zM10.75 9.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 1 0 0-1.5zM10 16.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAnnotationNumbers24);
